/**
 * Admin crash-report endpoints (Admin API, /api/admin/crash-reports).
 */

import { ApiService } from '../apiService'
import type {
  CrashGroup,
  CrashGroupQuery,
  CrashReportDetail,
  CrashReportPage,
  CrashReportQuery,
} from '../types/crashReports'

export const crashReportsApi = {
  /** One row per fingerprint seen in the window, newest last-seen first. */
  getGroups: (params: CrashGroupQuery) =>
    ApiService.get<CrashGroup[]>('/admin/crash-reports/groups', params),

  /** Individual reports, newest first, paged (page is 1-based on the wire). */
  getReports: (params: CrashReportQuery) =>
    ApiService.get<CrashReportPage>('/admin/crash-reports', params),

  /** One report with its stacks; the list omits them. */
  getReport: (id: string) =>
    ApiService.get<CrashReportDetail>(`/admin/crash-reports/${encodeURIComponent(id)}`),

  /** Deletes every report in a group — used once the bug behind it is fixed. */
  clearGroup: (fingerprint: string) =>
    ApiService.delete<void>(`/admin/crash-reports/groups/${encodeURIComponent(fingerprint)}`),
}
